import generateIcon from "../generateIcon";

const ChervonLeft = generateIcon("fas fa-chevron-circle-left");

export default ChervonLeft;